import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';

import CloseIcon from '@mui/icons-material/Close';
import RegistrationProfile from '../features/PreEnrollment/RegistrationProfile';
import { useEffect } from 'react';
import useProfileDrawerStore from '../stores/useProfileDrawerStore';
import { useAnalyticsContext } from '@/utils/analytics/AnalyticsContext';
import { canNavigateBack } from '@/shared/hooks';

const ProfileDrawer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { track } = useAnalyticsContext();

  const { profileDrawerShown, hideProfileDrawer, showProfileDrawer } = useProfileDrawerStore();

  useEffect(() => {
    if (!profileDrawerShown) return;

    track('Profile Drawer Shown', {
      title: 'PROFILE',
      url: location.pathname,
      path: location.pathname + '#profile-update',
      referrer: location.pathname,
    });
  }, [location.pathname, profileDrawerShown]);

  useEffect(() => {
    if (location?.hash === '#profile') {
      showProfileDrawer();
    }
  }, [location, showProfileDrawer]);

  useEffect(() => {
    if (profileDrawerShown) {
      const alreadyHasHash = location.hash === '#profile';
      // Preserve existing route state (e.g., isFirstProperty) when adding hash
      navigate({ hash: 'profile' }, { replace: alreadyHasHash, state: location.state });
      return;
    }

    if (location.hash !== '#profile') return;

    // Use canNavigateBack(1) - need at least 1 history entry to go back
    if (!canNavigateBack(1)) {
      // Preserve existing route state when removing hash
      navigate({ hash: '' }, { replace: true, state: location.state });
      return;
    }

    navigate(-1);
    // Note: location.state is intentionally excluded from deps to prevent infinite loops.
    // The History API creates new state object references on each navigation, which would
    // trigger this effect repeatedly. We only need to capture the current state value.
  }, [location.hash, navigate, profileDrawerShown]);

  return (
    <Drawer
      anchor="right"
      open={profileDrawerShown}
      onClose={hideProfileDrawer}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(8, 10, 45, 0.1)' } } }}
    >
      <Stack p={3} justifyContent="center" alignItems="center" maxWidth={513}>
        <Stack direction="row" style={{ width: '100%' }} justifyContent="space-between">
          <Box>
            <Typography variant="h4" id="ProfileHeader">
              Profile
            </Typography>
            <Typography id="ProfileSubHeader" sx={{ marginTop: '8px', marginBottom: '24px' }}>
              Edit your profile information below.
            </Typography>
          </Box>
          <Box>
            <IconButton
              color="inherit"
              aria-label="close drawer"
              style={{ position: 'relative', bottom: '10px' }}
              onClick={() => hideProfileDrawer()}
              edge="start"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Stack>
        <RegistrationProfile />
      </Stack>
    </Drawer>
  );
};
export default ProfileDrawer;
